import React from 'react'
import { Box, Grid, Typography , Paper, Container} from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";

const highlights = [
  {
    title: "Contribution",
    description: "Earn through referrals. ",
    image: imgUrl.contriIcon,
  },
  {
    title: "Eligibility",
    description: "Active social media presence with demonstrated values-driven content.",
    
    image: imgUrl.eligibilityIcon,
  },
  {
    title: "Goal",
    description: "Empower influencers to amplify Justice, Love & Peace worldwide.",
   
    image: imgUrl.goalIcon,
  },
  {
    title: "Global reach",
    description: "Open to influencers across all continents. ",
    
    image: imgUrl.goalReachIcon,
  },
];


const programIncludes = [
  <>
    	Partner with the <br></br> world’s  fastest  <br></br> growing <i><b> Justice, Love & Peace </b> </i> movement. 
  </>,
  <>
    Promote noble causes with official <i> <b>I Am Peacekeeper  </b></i>  campaigns. 
  </>,

  <>
    Access authorised official materials for your community. 
  </>,
  <>
    Enhance your <br></br> credibility <br></br> by aligning with <br></br> <i> <b>Nobel Peace <br></br> Laureates </b> </i>  
    and <br></br> <i> <b> Global  Leaders </b> </i>  . 
  </>,
  <>
    Share regular <br></br> reports with us on <br></br> your referrals  and rewards for full transparency. 
  </>,
  <>
    Receive <b>priority invites </b> to events, summits and campaigns. 
  </>,
  <>
    Join a supportive network of fellow <br></br> influencers dedicated to <i> <b>Justice, Love <br></br> &  Peace </b> </i> . 
  </>,

];

const whyJoin = [
  <>
    <b>Commission Rewards </b>	— <br></br> Earn 21% on successful <br></br> contributions made   <br></br>  through your referral link. 
  </>,
  <>
   <b>Recognition - </b> <br></br>   Acknowledgment in official <br></br> <i> I Am Peacekeeper </i> campaigns. 
  </>,

  <>
   <b> Global Listing </b> — <br></br> Inclusion on the <br></br> I Am Peacekeeper <br></br> Influencers directory.
  </>,
  <>
   <b>Events Access </b>	 — <br></br> Priority invites to <br></br> summits, conclaves <br></br> and launches. 
  </>,
  <>
   <b>Mentorship </b>  — <br></br> Invited to exclusive sessions <br></br> with movement <br></br> leaders and advisors.
  </>,
  <>
   <b>Training  </b> — <br></br> Join our official <i>IAP Courses </i>  <br></br> on Peace advocacy, including <br></br>
    the Inner Peace Course, Women in Peace Course and <br></br>  Peace Leadership Course. 
  </>,
  <>
  <b>Content Rights </b>  	 — <br></br> Access to official media <br></br> kits and approved assets. 
  </>,
  <>
    <b>Media Coverage </b> - <br></br> Opportunities for interviews and features. 
  </>,
  <>
   <b>Collaboration </b>  — <br></br> We will collaborate and <br></br> boost both our presences. 
  </>,
  <>
    <b>Impact Alignment </b>	 — <br></br> Your 	work will directly 
     embody and promote the 7 Human Values: Gratitude, Forgiveness, Love, <br></br>
     Humility, Giving, <br></br> Patience and Truth. 
  </>,
  <>
    <b>	Legacy Role </b> — <br></br> Become a recognised face <br></br> in building 
    the legacy of Global <br></br> Justice, Love <br></br> & Peace. 
  </>,
  <>
  <b> Pathways </b>  — <br></br> Opportunities for advanced roles <br></br> and leadership within <br></br> the movement. 
  </>
];



const circleCourses = [
  {
    text: (
      <>
        Join today as an <b>I Am Peacekeeper  Influencer.</b> 
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Amplify <b>Justice Love & Peace </b>  through your voice and network. 
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
      Earn recognition, rewards and respect. 
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
       Be the voice of Justice, Love & Peace to millions. 
      </>
    ),
    colorClass: "gradient-yellow",
  }
];

const ConclusionCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards gradientTrioBigCards ${colorClass}`}
    sx={{
      width: 140,
      height: 140,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const CircleBox = ({
  title,
  description,
  colorClass = "gradient-green",
  image,
}) => (
  <Box
    className={`circleBox ${colorClass}`}
    sx={{
      width: 180,
      height: 180,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 4,
      m: "auto",
    }}
  >
    <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="subtitle1" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
      {description}
    </Typography>
  </Box>
);

const ProgramCard = ({ text }) => (
  <Paper elevation={3} className="CircleCard">
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const InfoCard = ({ text }) => (
  <Paper elevation={3} className="infoCard">
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const BlockCard = ({  title,
  description,
  colorClass = "gradient-green",
  image, }) => (
  <Paper elevation={3} className="infoCard">
     <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem", fontFamily: 'var(--primary-font)', fontWeight: 400 }}>
      {description}
    </Typography>
  </Paper>
);

const Influencers = () => {
  return (
    <>
          {/* Influencer Hero Background Section */}
      <Box
        className="programInfluencerSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Influencer Main Section */}
      <Box className="" mt={5}>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid size={12} display="flex" alignItems="center" justifyContent="center" flexDirection="column">
              <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
              <Typography variant="h1" >
              <h1> I Am Peacekeeper Influencers </h1>
              </Typography>
            </Grid>

          </Grid>

        </Box>  

        <Box className="schoolProgramMainSection topBlockBox"  mt={5} >
         {/* <Typography
                    variant="h5"
                    align="center"
                    fontWeight="bold"
                    gutterBottom
                    className="subHeading"
                    pt={5}
                  >
                   TOP
                  </Typography> */}
           <Container className="paddingSubContainer">
          <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
            {highlights.map((item, index) => (
               <Grid size={{xs: 12, md: 3, sm: 6  }} key={index}>
                                 <BlockCard title={item.title}
                  description={item.description}
                  colorClass={item.colorClass}
                  image={item.image} 
                                  />
                               </Grid>
            ))}
          </Grid>
        </Container>
        </Box>

         {/* Program Includes Section */}
                <Box mt={5} className="programCardMain corporateMainSection mt-50px">
                  <Typography
                    variant="h2"
                    align="center"
                    fontWeight={400}
                    gutterBottom
                    className="subHeading mb-0px"
                    sx={{ fontFamily: 'var(--heading-font)' }}
                  >
                    Why Join?
                  </Typography>
                  {/* <p align="center">
                    Your organization’s partnership directly supports your Corporate
                    Social <br></br> Responsibility (CSR) goals
                  </p> */}
        
                  <Container className="paddingSubContainer programCardContainer mt-30px">
                    <Grid
                      container
                      spacing={2}
                      mt={1}
                      justifyContent="center"
                      alignItems="center"
                      display="flex"
                    >
                      {programIncludes.map((text, index) => (
                        <Grid
                          size={{ xs: 12, md: 3, sm: 4 }}
                          key={index}
                          justifyContent="center"
                          alignItems="center"
                          display="flex"
                        >
                          <ProgramCard text={text} />
                        </Grid>
                      ))}
                    </Grid>
                  </Container>
                </Box>

                 {/* why schools should join */}
                 <Box className="schoolProgramMainSection whatYouReceiveInfluence">
                    <Typography
                           variant="h2"
                           align="center"
                           fontWeight={400}
                           gutterBottom
                           mt={5}
                           className="subHeading mt-50px"
                           sx={{ fontFamily: 'var(--heading-font)' }}
                         >
                          What You Receive
                         </Typography>
                         <Container className="paddingSubContainer">
                           <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
                             {whyJoin.map((text, index) => (
                               <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                                 <InfoCard text={text} 
                                  />
                               </Grid>
                             ))}
                           </Grid>
                         </Container>
                 </Box>  

                  <Box
                         sx={{
                           textAlign: "center",
                           borderRadius: 3,
                           marginBottom:'70px'
                         }}
                         mt={5}
                         className="TabPaddingContainer TabInfluencer">
                        {/* Title */}
                         <Typography
                           variant="h2"
                           fontWeight={400}
                           gutterBottom
                           className="subHeading"
                           sx={{ fontFamily: 'var(--heading-font)' }}
                         >
                         Closing
                         </Typography>
                        <Container className="paddingContainer mt-50px" mb={5}>
                           <Grid container spacing={5} justifyContent="center" mb={4}>
                             {circleCourses.map(({ text, colorClass }, index) => (
                               <Grid size={{ xs: 12, sm: 3, md: 2 }} key={index}>
                                 <ConclusionCard text={text} colorClass={colorClass} />
                               </Grid>
                             ))}
                           </Grid>
                         </Container>
                  </Box>     
                  
                


    </>
  )
}

export default Influencers